"use client"

import type React from "react"

import { ThemeProvider } from "@/components/theme-provider"
import { AuthProvider } from "@/app/context/AuthContext"
import { BillableActionsProvider } from "@/app/context/BillableActionsContext"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <AuthProvider>
        <BillableActionsProvider>{children}</BillableActionsProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}
